'use client';

import { useEffect, useRef, useState } from 'react';
import getEnvValue from '@/commons/getEnvValue';

const InitAlgoliaInsights = () => {
  const [, setStatus] = useState('idle');
  const initAttemptRef = useRef(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const run = async () => {
      initAttemptRef.current += 1;
      setStatus('loading');

      const appId =
        getEnvValue('NEXT_PUBLIC_ALGOLIA_APPID') ??
        getEnvValue('REACT_APP_ALGOLIA_APPID');
      const apiKey =
        getEnvValue('NEXT_PUBLIC_ALGOLIA_APIKEY') ??
        getEnvValue('REACT_APP_ALGOLIA_APIKEY');

      if (!appId || !apiKey) {
        setStatus('error');
        return;
      }

      try {
        const mod = await import('search-insights');
        const aa = mod.default;

        if (typeof aa !== 'function') {
          setStatus('error');
          return;
        }

        aa('init', { appId, apiKey, useCookie: true });

        window.aa = aa;
        window.algoliaInitialized = true;
        setStatus('ready');
      } catch (e) {
        setStatus('error');
      }
    };

    run();
  }, []);

  return null;
};

export default InitAlgoliaInsights;
